module.exports = __webpack_public_path__ + "static/media/aiony-haust-667702-unsplash.35fb66ce.jpg";